<mat-tab-group matDialogTitle>
    <mat-tab #versionTab
             aria-label="process-version-management">
        <ng-template mat-tab-label>
            {{ 'processes_versions_modal_title' | translate }}
        </ng-template>
    </mat-tab>
    <mat-tab #argumentTab
             aria-label="process-parameters">
        <ng-template mat-tab-label>
            {{ 'processes_versions_parameters_modal_title' | translate }}
        </ng-template>
    </mat-tab>
</mat-tab-group>

<mat-dialog-content>
    <p data-cy="process-name">
        <strong translate>process_versions_package_placeholder</strong>: {{context.data.processKey}}
        v{{context.data.processVersion}}
    </p>
    <p data-cy="process-environment-name">
        <strong translate>process_versions_environment_placeholder</strong>: {{context.data.environmentName}}
    </p>
    <ui-process-versions-grid [hidden]="!versionTab.isActive"
                              [release]="context.data"
                              (update)="onUpdate($event)">
    </ui-process-versions-grid>
    <form [formGroup]="formGroup"
          (submit)="$event.preventDefault()">
        <ui-process-io-parameters #parameterGrid
                                  [hidden]="!argumentTab.isActive"
                                  [editable]="isProcessEditAllowed$ | async"
                                  [args]="context.data.arguments"
                                  formControlName="arguments">
        </ui-process-io-parameters>
    </form>
</mat-dialog-content>

<mat-dialog-actions *ngLet="{
                        loading: loading$ | async
                    } as state"
                    align="end">
    <button (click)="onClose()"
            mat-button
            type="button"
            data-cy="version-management-close">
        {{ (context.isNewEntry ? 'modal_action_cancel' : 'modal_action_close') | translate }}
    </button>
    <button *ngIf="argumentTab.isActive"
            [spinnerButtonLoading]="state.loading"
            [disabled]="state.loading ||
                        formGroup.pristine ||
                        formGroup.invalid ||
                        parameterGrid?.isOpen"
            (click)="updateParameters(formGroup.get('arguments')!.value)"
            ui-spinner-button
            mat-flat-button
            type="button"
            color="primary">
        {{'modal_action_update' | translate}}
    </button>
</mat-dialog-actions>
